import React from 'react';

export default class LobbyFriendsPanel extends React.Component
{
  render()
  {
    return (
      <>
        <div className="lobby-friends-panel-title">FRIENDS</div>

        <div className="lobby-friends-panel-subsection lobby-friends-panel-subsection-online">
          <div className="lobby-friends-panel-subsection-title">Online</div>
          <img className="lobby-friends-panel-subsection-avatar" src={ process.env.PUBLIC_URL + '/avatars/meeple-ui-circle-player-white.png' } alt="Avatar icon" />
          <div className="lobby-friends-panel-subsection-coming-soon">Coming Soon</div>
        </div>

        <div className="lobby-friends-panel-subsection lobby-friends-panel-subsection-offline">
          <div className="lobby-friends-panel-subsection-title">Offline</div>
          <img className="lobby-friends-panel-subsection-avatar" src={ process.env.PUBLIC_URL + '/avatars/meeple-ui-circle-player-white.png' } alt="Avatar icon" />
          <div className="lobby-friends-panel-subsection-coming-soon">Coming Soon</div>
        </div>
      </>
    );
  }
};
